import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Moment } from 'moment';

@Component({
    selector: 'app-certificate-date-filter-dialog',
    templateUrl: './certificate-date-filter-dialog.component.html',
    styleUrls: ['./certificate-date-filter-dialog.component.scss'],
})
export class CertificateDateFilterDialogComponent implements OnInit {
    dateFilterForm: FormGroup;

    @Input()
    before: Moment;

    @Input()
    after: Moment;

    constructor(private _fb: FormBuilder, public dialogRef: MatDialogRef<CertificateDateFilterDialogComponent>) {}

    ngOnInit(): void {
        this.dateFilterForm = this._fb.group({
            before: [this.before || null],
            after: [this.after || null],
        });
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        if (this.dateFilterForm.valid) {
            this.dialogRef.close(this.dateFilterForm.value);
        }
    }
}
